import { LoaderActionTypes } from '../actions/loader';

interface ILoaderState {
  showLoader: boolean;
}

interface ILoaderAction {
  type: LoaderActionTypes;
}

const initalState: ILoaderState = {
  showLoader: false,
};

export default function loaderReducer(
  state = initalState,
  action: ILoaderAction
): ILoaderState {
  switch (action.type) {
    case LoaderActionTypes.SHOW_LOADER: {
      return {
        ...state,
        showLoader: true,
      };
    }
    case LoaderActionTypes.HIDE_LOADER: {
      return {
        ...state,
        showLoader: false,
      };
    }
    default:
      return state;
  }
}
